import { Collapse } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { ThirdPartyMessageType } from '../../../../common/enums/thirdPartyMessageType';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { getJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import {
    AdminProcessNullableFormattedDatetime,
    AdminTable,
    DropdownLink,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableRow,
} from '../../elements/common';

interface IAdminProcessDetailsThirdPartyMessagesProps {
    adminProcess: AdminProcess;
    reload: boolean | undefined;
}

export interface IThirdPartyMessage {
    finishedDateTime: string;
    firstScheduledDateTime: string;
    id: string;
    messageSubtype: string;
    messageType: ThirdPartyMessageType;
    recipient: string;
    status: string;
}

export function AdminProcessDetailsThirdPartyMessages(props: IAdminProcessDetailsThirdPartyMessagesProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [thirdPartyMessages, setThirdPartyMessages] = useState<IThirdPartyMessage[]>([]);

    useEffect(() => {
        loadThirdPartyMessages(props.adminProcess.id);
    }, [props.adminProcess.id]);

    useEffect(() => {
        if (props.reload) {
            loadThirdPartyMessages(props.adminProcess.id);
        }
    }, [props.reload]);

    return (
        <>
            <DropdownLink
                labelLess={translateKey('processDetails.thirdPartyMessages')}
                labelMore={translateKey('processDetails.thirdPartyMessages')}
                onClick={() => setIsOpen(!isOpen)}
                open={isOpen}
            />

            <Collapse isOpen={isOpen}>
                <AdminTable>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translateKey('processThirdPartyMessages.messageType')}</TableHeader>
                            <TableHeader>{translateKey('processThirdPartyMessages.messageSubtype')}</TableHeader>
                            <TableHeader>{translateKey('processThirdPartyMessages.recipient')}</TableHeader>
                            <TableHeader>{translateKey('common.status')}</TableHeader>
                            <TableHeader>
                                {translateKey('processThirdPartyMessages.firstScheduledDateTime')}
                            </TableHeader>
                            <TableHeader>{translateKey('processThirdPartyMessages.finishedDateTime')}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {thirdPartyMessages &&
                            thirdPartyMessages.map((thirdPartyMessage, i) => (
                                <TableRow key={'thirdPartyMessage' + i}>
                                    <TableData>{thirdPartyMessage.messageType}</TableData>
                                    <TableData>{thirdPartyMessage.messageSubtype}</TableData>
                                    <TableData>{thirdPartyMessage.recipient}</TableData>
                                    <TableData>
                                        {translateKey('processThirdPartyMessages.' + thirdPartyMessage.status)}
                                    </TableData>
                                    <TableData>
                                        <AdminProcessNullableFormattedDatetime
                                            value={thirdPartyMessage.firstScheduledDateTime}
                                        />
                                    </TableData>
                                    <TableData>
                                        <AdminProcessNullableFormattedDatetime
                                            value={thirdPartyMessage.finishedDateTime}
                                        />
                                    </TableData>
                                </TableRow>
                            ))}
                    </TableBody>
                </AdminTable>
            </Collapse>
        </>
    );

    async function loadThirdPartyMessages(requestId: string) {
        const result = await getJson(`/api/requests/${requestId}/thirdPartyMessages`);
        setThirdPartyMessages(result.json.items);
    }
}
